import React from 'react';

import Ingredients from './Ingredients/Ingredients';

import classes from './burger.module.css';

const Burger = (props) => {

    const listOfIngredients = Object.keys(props.ingredients)
    .map(
        (keys,index) => {
            return [...Array(props.ingredients[keys])].map((_,index) => {
               return <Ingredients key={keys + '_' + index} 
               typeOfIngredient={keys} />
            });
        }).reduce((previous , current) => {
            return previous.concat(current);
        },[]);

    return(
        <div className={classes.Burger} style={props.overide}>
            <Ingredients typeOfIngredient="bread-top"></Ingredients>
            { listOfIngredients.length > 0 ? 
                listOfIngredients : 
                <p>Please Add some Ingredients</p>
            }
            <Ingredients typeOfIngredient="bread-bottom"></Ingredients>
        </div>
    );
}

export default Burger;